import { h, Host } from "@stencil/core";
import { getUniqueId } from "../../utils/unique-id";
export class RadioButton {
    constructor() {
        this.value = "";
        this.label = "";
        this.inputId = undefined;
        this.name = "";
        this.checked = false;
        this.disabled = false;
        this.required = false;
        this.error = false;
        this.errorMsg = null;
        this.withBorder = false;
        this.asBox = false;
        this.hasMedia = false;
        this.hasDescription = false;
        this.isDescriptionActive = false;
        this.borderActive = this.withBorder && this.checked;
        this.groupName = null;
    }
    radioButtonElement = null;
    radioInputElement;
    labelElement = null;
    descriptionToggleButton = null;
    // @ts-expect-error Check for typing
    descriptionModal = null;
    element;
    setInputId() {
        this.inputId = this.inputId || getUniqueId();
    }
    componentWillLoad() {
        this.setInputId();
        this.hasMedia = !!this.element.querySelector('[slot="media"]');
        this.hasDescription = !!this.element.querySelector('[slot="description"]');
    }
    componentDidLoad() {
        this.checkForButtonGroup();
    }
    checkForButtonGroup = () => {
        /** check if outer radio button group exists*/
        // @ts-expect-error Check for typing
        if (this.radioButtonElement.closest(".ux-radio-button-group") === null) {
            return;
        }
        // @ts-expect-error Check for typing
        this.groupName = this.radioButtonElement.closest(".ux-radio-button-group").getAttribute("name");
        return this.groupName;
    };
    handleComponentClick = (e) => {
        const eTarget = e.target;
        if (eTarget !== this.radioButtonElement &&
            eTarget !== this.radioInputElement &&
            eTarget !== this.descriptionToggleButton &&
            !(this.descriptionModal !== null && eTarget.closest(`ux-modal`) === this.descriptionModal)) {
            if (!this.radioInputElement.checked) {
                this.radioInputElement.checked = true;
                this.onRadioButtonChange();
            }
        }
    };
    /** radio button event, will be emitted when the radio button becomes active */
    radioButtonEvent;
    onRadioButtonChange = () => {
        this.radioButtonEvent.emit({
            name: this.name,
            value: this.value,
            // @ts-expect-error Check for typing
            inputId: this.inputId,
            checked: this.radioInputElement?.checked
        });
    };
    handleElementBorder(e) {
        if (!this.withBorder) {
            return;
        }
        if (e.target === this.element) {
            this.borderActive = true;
        }
        else if (this.name === e.detail.name) {
            this.borderActive = false;
        }
    }
    /** returns the innerHTML of the label element */
    async getLabel() {
        // @ts-expect-error Check for typing
        return this.labelElement.innerHTML;
    }
    handleDescription = (e) => {
        e.stopImmediatePropagation();
        this.isDescriptionActive = !this.isDescriptionActive;
    };
    render() {
        /** base class is ux-radio-button-field because ux-radio-button is already used by the radio-button static component */
        const baseClass = "ux-radio-button-field";
        const { value, label, inputId, name, checked, disabled, required, error, errorMsg } = this;
        const radioName = this.groupName !== null ? this.checkForButtonGroup() : name;
        const handleBoxClick = this.hasMedia || this.withBorder || this.asBox || this.hasDescription;
        return (h(Host, { key: '1c7cf8d2c3b1607a24dbd9adbfb9631870e49630', class: {
                [baseClass]: true,
                [`${baseClass}--with-media`]: this.hasMedia,
                [`${baseClass}--active`]: this.checked,
                [`${baseClass}--as-box`]: (this.hasDescription && !this.hasMedia) || this.asBox
            }, onClick: handleBoxClick ? this.handleComponentClick : null }, h("div", { key: '790590b69cc001b6b4999cdb27a537c886a12707', style: { display: this.hasMedia ? "block" : "none" }, class: `${baseClass}__media-container` }, h("slot", { key: '163d4e2ebb39274df0f479411021174e1c0517a0', name: "media" })), h("div", { key: '577acc5a4e0f25175387b09832ebb372c0f2fc06', class: `${baseClass}__label-container` }, this.borderActive && h("div", { key: 'abc6c1d5710a2dc89ad2137e7b3363d33a6ec492', class: `${baseClass}__border` }), h("label", { key: '8392bccbbcdd00725791d59082d955324c96805f', class: {
                [`ux-radio-button`]: true,
                [`ux-radio-button--disabled`]: disabled,
                [`ux-radio-button--error`]: error
            },
            // @ts-expect-error Check for typing
            ref: (el) => (this.radioButtonElement = el) }, h("input", { key: 'e146b7c5a1d3e5390df0d221e4641a0f12c49615', class: "ux-radio-button__input", type: "radio", id: inputId,
            // @ts-expect-error Check for typing
            name: radioName, value: value, checked: checked, disabled: disabled, required: required,
            // @ts-expect-error Check for typing
            ref: (el) => (this.radioInputElement = el), onChange: this.onRadioButtonChange, "aria-invalid": error ? "true" : "false" }), h("span", { key: '7d6575bfbd64a546bf7a5f895608546a44fe842a', class: "ux-radio-button__label", ref: (el) => (this.labelElement = el) }, label, h("slot", { key: '9ea27de3c574c1aa8c4d064c90f478b2c9b2b190' }), required && h("span", { key: '632657d9ab2b1322c491e606bef4fbade62a0860' }, " *"), " ", error && errorMsg !== "" && h("span", { key: '70f59fadf29002381ec2b419533fe411f31fe96b', class: "ux-label__error-message" }, errorMsg))), this.hasDescription && (h("button", { key: 'a57db807ce3d1c2476ef3d79c726a6f01b22cbb8', class: `${baseClass}__description-toggle`,
            // @ts-expect-error Check for typing
            onClick: this.hasDescription ? this.handleDescription : null, type: "button",
            // @ts-expect-error Check for typing
            ref: (el) => (this.descriptionToggleButton = el) }, h("ux-icon", { key: '452837a2c3832f9d47bf9a145cfe5fd11691b72c', name: "square-info", weight: "bold", "size-s": "15" })))), this.hasDescription && (h("ux-modal", { key: '38aa97f8b76acb0ce36a672a641e7001e9ec490d', opened: this.isDescriptionActive, name: "description-modal" + this.inputId, onUxModalClose: () => (this.isDescriptionActive = false), "no-gutter-top": true,
            // @ts-expect-error Check for typing
            ref: (el) => (this.descriptionModal = el), closeOnEscKey: true, closeOnBackdropClick: true }, h("slot", { key: '6ab7c8f00065fcbdbe2445016c654913af9e0b56', name: "description" })))));
    }
    static get is() { return "ux-radio-button"; }
    static get originalStyleUrls() {
        return {
            "$": ["radio-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["radio-button.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "value of the input element, not visible to the user"
                },
                "attribute": "value",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "text inside the radio button label element, visible to the user"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Input id attribute"
                },
                "attribute": "input-id",
                "reflect": false
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name which is used for radio button groups or as identifier in forms"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the radio button is checked"
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the radio button is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the radio button is required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the radio button has an error state"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message that is rendered if component has an error"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "null"
            },
            "withBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, a green border will be applied to the radio button area when selected"
                },
                "attribute": "with-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "asBox": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, the checkbox will be displayed as a box with shadow"
                },
                "attribute": "as-box",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "hasMedia": {},
            "hasDescription": {},
            "isDescriptionActive": {},
            "borderActive": {},
            "groupName": {}
        };
    }
    static get events() {
        return [{
                "method": "radioButtonEvent",
                "name": "uxRadioButtonChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "radio button event, will be emitted when the radio button becomes active"
                },
                "complexType": {
                    "original": "{\n        name: string;\n        value: string;\n        inputId: string;\n        checked: boolean;\n    }",
                    "resolved": "{ name: string; value: string; inputId: string; checked: boolean; }",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "getLabel": {
                "complexType": {
                    "signature": "() => Promise<string>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<string>"
                },
                "docs": {
                    "text": "returns the innerHTML of the label element",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "inputId",
                "methodName": "setInputId"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxRadioButtonChange",
                "method": "handleElementBorder",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=radio-button.js.map
